import React, { Suspense, useEffect, useState } from 'react'
import { Canvas, useThree } from '@react-three/fiber'
import { Environment, Float, Lightformer, OrbitControls } from '@react-three/drei'
import { useSnapshot } from 'valtio'

import './styles.css'
import Model from './Xbox-model-compact'
import { state } from './store'
import CameraRig from './CameraRig'
import Particles from './Particles'
import Stars from './Stars'

// Touch device ekanligini aniqlash
const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}

// Kamerani offset qilish uchun component
function CameraOffset({ offsetX = 0 }) {
  const { camera, size } = useThree()

  useEffect(() => {
    if (offsetX !== 0) {
      camera.setViewOffset(
        size.width,
        size.height,
        -offsetX * size.width,
        0,
        size.width,
        size.height
      )
    }
    return () => camera.clearViewOffset()
  }, [camera, size, offsetX])

  return null
}

function Scene() {
  const { selectedColor } = useSnapshot(state)
  const [modelScale, setModelScale] = useState(0.1)
  const [cameraOffset, setCameraOffset] = useState(0.15)
  const [isTouch, setIsTouch] = useState(false)

  useEffect(() => {
    // Touch device ni aniqlash
    setIsTouch(isTouchDevice())

    const handleResize = () => {
      const width = window.innerWidth

      // Responsive scale va offset
      if (width < 400) {
        setModelScale(0.055)
        setCameraOffset(0)
      } else if (width < 500) {
        setModelScale(0.065)
        setCameraOffset(0.05)
      } else if (width < 700) {
        setModelScale(0.075)
        setCameraOffset(0.08)
      } else if (width < 900) {
        setModelScale(0.085)
        setCameraOffset(0.1)
      } else {
        setModelScale(0.1)
        setCameraOffset(0.15)
      }
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <Canvas
      camera={{ position: [0, 0, 5], fov: 25 }}
      dpr={[1, 2]}
      gl={{
        alpha: true,
        antialias: true,
        powerPreference: 'high-performance',
        stencil: false,
        depth: true
      }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        zIndex: 0,
        pointerEvents: isTouch ? 'none' : 'auto'
      }}
    >
      <CameraOffset offsetX={cameraOffset} />

      {/* PC/Laptop uchun OrbitControls */}
      {!isTouch && (
        <OrbitControls
          enableZoom={false}
          enablePan={false}
          enableRotate={true}
          rotateSpeed={0.5}
          dampingFactor={0.05}
          enableDamping={true}
        />
      )}

      <Suspense fallback={null}>
        <CameraRig>
          <Float speed={2} rotationIntensity={0.2} floatIntensity={0.4}>
            <Model
              transitionColor={selectedColor}
              scale={modelScale}
              rotation={[0, 0, 0]}
              castShadow
              receiveShadow
            />
          </Float>
        </CameraRig>

        <Environment preset='city' intensity='0.5'>
          <Lightformer intensity={10} rotation-y={Math.PI / 2} position={[-50, 2, 0]} scale={[100, 2, 1]} />
          <Lightformer intensity={10} rotation-y={-Math.PI / 2} position={[20, 50, 0]} scale={[100, 2, 1]} />
        </Environment>

        <Particles particlesCount={100} />
        <Stars />
      </Suspense>
    </Canvas>
  )
}

export default Scene
